export const UPDATE_LOCATION = 'location.updateLocation';
